export const THEME_KEYS = {
  RECOMMENDED: 'recommended',
  CREAMY: 'creamy',
  CONTEMPORARY: 'contemporary',
  MATURE: 'mature',
  NOSTALGIC: 'nostalgic',
  TECHNICAL: 'technical',
} as const;

export type ThemeKey = (typeof THEME_KEYS)[keyof typeof THEME_KEYS];

export const THEME_COLORS = {
  [THEME_KEYS.RECOMMENDED]: {},
  [THEME_KEYS.CREAMY]: {
    color_11: '#0B3910',
    color_12: '#6E1919',
    color_13: '#939991',
    color_14: '#C5C7BF',
    color_15: '#FFF8EB',
    color_18: '#E4C58A',
    color_28: '#E4C58A',
    color_33: '#6E1919',
    color_36: '#0B3910',
    color_37: '#FFF8EB',
    color_38: '#505C50',
    color_39: '#939991',
    color_40: '#C5C7BF',
    color_41: '#6E1919',
    color_42: '#E4C58A',
    color_43: '#F08475',
    color_44: '#E1D9C7',
    color_45: '#FFF8EB',
    color_46: '#FFF8EB',
    color_47: '#FFF8EB',
    color_48: '#FFF8EB',
    color_49: '#FFF8EB',
    color_50: '#0B3910',
    color_51: '#0B3910',
    color_52: '#FFF8EB',
    color_53: '#FFF8EB',
    color_54: '#C5C7BF',
    color_55: '#C5C7BF',
    color_56: '#505C50',
    color_57: '#0B3910',
    color_58: '#FFF8EB',
    color_59: '#FFF8EB',
    color_60: '#FFF8EB',
    color_61: '#FFF8EB',
    color_62: '#0B3910',
    color_63: '#C5C7BF',
    color_64: '#C5C7BF',
    color_65: '#505C50',
  },
  [THEME_KEYS.CONTEMPORARY]: {
    color_11: '#FFF8F1',
    color_12: '#E0BE9A',
    color_13: '#808080',
    color_14: '#404040',
    color_15: '#000000',
    color_18: '#5B4D43',
    color_28: '#E0BE9A',
    color_33: '#FFF8F1',
    color_37: '#000000',
    color_38: '#D2D2D2',
    color_39: '#808080',
    color_40: '#404040',
    color_41: '#FFF8F1',
    color_42: '#E0BE9A',
    color_43: '#5B4D43',
    color_44: '#A2672D',
    color_45: '#000000',
    color_46: '#000000',
    color_47: '#000000',
    color_48: '#FFF8F1',
    color_49: '#5B4D43',
    color_50: '#5B4D43',
    color_51: '#5B4D43',
    color_52: '#5B4D43',
    color_53: '#FFF8F1',
    color_54: '#808080',
    color_55: '#808080',
    color_57: '#5B4D43',
    color_58: '#5B4D43',
    color_59: '#FFF8F1',
    color_60: '#FFF8F1',
    color_61: '#5B4D43',
    color_62: '#5B4D43',
    color_63: '#808080',
    color_64: '#808080',
    color_65: '#FFFFFF',
  },
  [THEME_KEYS.MATURE]: {
    color_12: '#FEE6C4',
    color_13: '#808080',
    color_14: '#404040',
    color_15: '#000000',
    color_18: '#000000',
    color_28: '#FEE6C4',
    color_33: '#633761',
    color_37: '#000000',
    color_38: '#BFBFBF',
    color_39: '#808080',
    color_40: '#404040',
    color_41: '#633761',
    color_42: '#FEE6C4',
    color_43: '#30574E',
    color_44: '#91ABA5',
    color_45: '#000000',
    color_46: '#000000',
    color_47: '#000000',
    color_48: '#633761',
    color_49: '#633761',
    color_51: '#FEE6C4',
    color_52: '#633761',
    color_53: '#633761',
    color_54: '#404040',
    color_55: '#404040',
    color_56: '#BFBFBF',
    color_57: '#FEE6C4',
    color_58: '#633761',
    color_59: '#633761',
    color_60: '#633761',
    color_61: '#633761',
    color_63: '#404040',
    color_64: '#404040',
    color_65: '#BFBFBF',
  },
  [THEME_KEYS.NOSTALGIC]: {
    color_12: '#FFF0EC',
    color_13: '#94949B',
    color_14: '#5E5F68',
    color_15: '#282936',
    color_18: '#C2274B',
    color_28: '#FFF0EC',
    color_33: '#C2274B',
    color_37: '#282936',
    color_38: '#C9CACD',
    color_39: '#94949B',
    color_40: '#5E5F68',
    color_41: '#C2274B',
    color_42: '#FFF0EC',
    color_43: '#B4C8DC',
    color_44: '#556B8D',
    color_45: '#282936',
    color_46: '#282936',
    color_47: '#282936',
    color_48: '#C2274B',
    color_49: '#C2274B',
    color_51: '#FFF0EC',
    color_52: '#C2274B',
    color_53: '#C2274B',
    color_54: '#94949B',
    color_55: '#94949B',
    color_57: '#FFF0EC',
    color_58: '#C2274B',
    color_59: '#C2274B',
    color_60: '#C2274B',
    color_61: '#C2274B',
    color_63: '#94949B',
    color_64: '#94949B',
    color_65: '#FFFFFF',
  },
  [THEME_KEYS.TECHNICAL]: {
    color_11: '#F6F6F6',
    color_12: '#BDE9FB',
    color_13: '#8F8898',
    color_14: '#5C5168',
    color_15: '#281A39',
    color_18: '#281A39',
    color_28: '#BDE9FB',
    color_33: '#2061B7',
    color_36: '#F6F6F6',
    color_37: '#281A39',
    color_38: '#C3BFC7',
    color_39: '#8F8898',
    color_40: '#5C5168',
    color_41: '#2061B7',
    color_42: '#BDE9FB',
    color_43: '#EAE0DA',
    color_44: '#D0E0CD',
    color_45: '#281A39',
    color_46: '#281A39',
    color_47: '#281A39',
    color_48: '#281A39',
    color_49: '#281A39',
    color_50: '#F6F6F6',
    color_51: '#BDE9FB',
    color_52: '#281A39',
    color_53: '#281A39',
    color_54: '#8F8898',
    color_55: '#8F8898',
    color_56: '#F6F6F6',
    color_57: '#BDE9FB',
    color_58: '#281A39',
    color_59: '#281A39',
    color_60: '#281A39',
    color_61: '#281A39',
    color_62: '#F6F6F6',
    color_63: '#8F8898',
    color_64: '#8F8898',
    color_65: '#F6F6F6',
  },
  // [THEME_KEYS.SAVVY]: {
  //   color_11: '#231B3B',
  //   color_12: '#483778',
  //   color_13: '#6F658C',
  //   color_14: '#C7C1D9',
  //   color_15: '#FFFFFF',
  //   color_18: '#FF7FE8',
  //   color_28: '#DEFF00',
  //   color_33: '#FF7FE8',
  //   color_36: '#231B3B',
  //   color_37: '#FFFFFF',
  //   color_38: '#483778',
  //   color_39: '#6F658C',
  //   color_40: '#C7C1D9',
  //   color_41: '#FF7FE8',
  //   color_42: '#DEFF00',
  //   color_43: '#8051FF',
  //   color_44: '#72FFFF',
  //   color_45: '#FFFFFF',
  //   color_46: '#FFFFFF',
  //   color_47: '#FF7FE8',
  //   color_48: '#231B3B',
  //   color_49: '#FF7FE8',
  //   color_50: '#FF7FE8',
  //   color_51: '#FF7FE8',
  //   color_52: '#FF7FE8',
  //   color_53: '#231B3B',
  //   color_54: '#C7C1D9',
  //   color_55: '#C7C1D9',
  //   color_56: '#6F658C',
  //   color_57: '#FF7FE8',
  //   color_58: '#FF7FE8',
  //   color_59: '#231B3B',
  //   color_60: '#231B3B',
  //   color_61: '#FF7FE8',
  //   color_62: '#FF7FE8',
  //   color_63: '#C7C1D9',
  //   color_64: '#C7C1D9',
  //   color_65: '#6F658C',
  // },
} as const;
